<template>
  <div class="bar-3">
    <div class="circule-overlay-firth"></div>
    <div class="circule-overlay-second"></div>

    <div class="container-news">
      <div class="news-top">
        <router-link
          :to="
            $i18nRoute({
              name: 'NewsDetail',
              params: { slug: item.url }
            })
          "
          class="card"
          :class="`card-${index + 1}`"
          v-for="(item, index) in list.slice(0, 4)"
          :key="item.id"
        >
          <div class="card__img">
            <ImageContainer
              class="img"
              :src="item.image.medium"
              :thumb="item.image.thumbnail"
              :alt="item.title"
            />
          </div>
          <div class="card__content">
            <div class="opacity-content"></div>
            <div class="card__category">
              <div>{{ item.sub_category.name }}</div>
            </div>
            <div class="card__title">
              <h3 class="limited-text">
                {{ item.title }}
              </h3>
            </div>
            <div class="data-news">
              <span class="day">{{ handleDate(item.pub_date) }}, </span>
              <span class="time">{{ handleTime(item.pub_date) }}</span>
            </div>
          </div>
        </router-link>
      </div>
      <div class="news-bottom">
        <router-link
          :to="
            $i18nRoute({
              name: 'NewsDetail',
              params: { slug: item.url }
            })
          "
          class="card"
          :class="`card-${index + 1}`"
          v-for="(item, index) in list.slice(4, 6)"
          :key="item.id"
        >
          <div class="card__img">
            <ImageContainer
              class="img"
              :src="item.image.medium"
              :thumb="item.image.thumbnail"
              :alt="item.title"
            />
          </div>
          <div class="card__content">
            <div class="opacity-content"></div>
            <div class="card__category">
              <div>{{ item.sub_category.name }}</div>
            </div>
            <div class="card__title">
              <h3 class="limited-text">
                {{ item.title }}
              </h3>
            </div>
            <div class="data-news">
              <span class="day">{{ handleDate(item.pub_date) }}, </span>
              <span class="time">{{ handleTime(item.pub_date) }}</span>
            </div>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import ImageContainer from "@/components/ImageContainer";
import { useFormatter } from "@/utils/formatter";

export default {
  components: { ImageContainer },
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  setup() {
    return {
      ...useFormatter()
    };
  }
};
</script>

<style lang="scss" scoped>
.bar-3 {
  width: 100%;
  position: relative;
}
.container-news {
  width: 90%;
  margin: 0 auto;
}
.circule-overlay-firth,
.circule-overlay-second {
  width: 350px;
  height: 350px;
  position: absolute;
  background: rgba(31, 45, 101, 0.7);
  filter: blur(224px);
  border-radius: 282px;
}
.circule-overlay-firth {
  top: 10%;
  left: -20%;
}
.circule-overlay-second {
  top: 60%;
  right: -20%;
}
.news-top {
  --border-width: 2rem;
  --border-color: #9786a6;
  --offset-img: 5rem;

  display: flex;
  flex-wrap: nowrap;
  gap: var(--border-width);
  .card {
    flex: 1;
    &__img {
      padding: var(--border-width) 0;
      .img {
        padding-bottom: 75%;
      }
    }
    &__content {
      width: 90%;
      margin: 0 auto;
    }
    .data-news {
      text-align: right;
    }
  }
  .card-1 {
    .card__img {
      position: relative;
      &::before {
        content: "";
        position: absolute;
        height: var(--border-width);
        width: 200%;
        background: var(--border-color);
        top: 0;
        left: -100%;
      }
      &::after {
        content: "";
        position: absolute;
        width: var(--border-width);
        height: calc(100% + var(--offset-img));
        background: var(--border-color);
        top: 0;
        right: calc(0rem - var(--border-width));
      }
    }
  }
  .card-2,
  .card-4 {
    .card__category {
      margin-top: 0.5rem;
    }
  }
  .card-2 {
    .card__img {
      position: relative;
      margin-top: var(--offset-img);
      &::before {
        content: "";
        position: absolute;
        height: var(--border-width);
        width: 100%;
        background: var(--border-color);
        bottom: 0;
        left: 0;
      }
      &::after {
        content: "";
        position: absolute;
        width: var(--border-width);
        height: calc(100% + var(--offset-img));
        background: var(--border-color);
        bottom: 0;
        right: calc(0rem - var(--border-width));
      }
    }
  }
  .card-3 {
    .card__img {
      position: relative;
      &::before {
        content: "";
        position: absolute;
        height: var(--border-width);
        width: 100%;
        background: var(--border-color);
        top: 0;
        left: 0;
      }
      &::after {
        content: "";
        position: absolute;
        width: var(--border-width);
        height: calc(100% + var(--offset-img));
        background: var(--border-color);
        top: 0;
        right: calc(0rem - var(--border-width));
      }
    }
  }
  .card-4 {
    .card__img {
      position: relative;
      margin-top: var(--offset-img);
      &::before {
        content: "";
        position: absolute;
        height: var(--border-width);
        width: 200%;
        background: var(--border-color);
        bottom: 0;
        left: 0;
      }
    }
  }
}
.news-bottom {
  margin-top: 5rem;
  --translate-content: 8%;
  display: flex;
  gap: 2rem;
  .card {
    flex: 1;
    display: flex;
    align-items: flex-end;
    &__img {
      flex: 0 0 65%;

      .img {
        padding-bottom: 64%;
      }
    }
    &__content {
      margin-bottom: 2rem;
    }
  }
  .card-1 {
    .card__content {
      text-align: right;
      transform: translateX(var(--translate-content));
      .data-news {
        line-height: 1.5 !important;
        text-align: left;
      }
    }
    .card__img {
      clip-path: polygon(0 0, 100% 0, 100% 100%, 25% 100%);
    }
    .card__content {
      order: 1;
    }
    .card__img {
      order: 2;
    }
  }
  .card-2 {
    .card__content {
      transform: translateX(calc(0% - var(--translate-content)));
      .data-news {
        line-height: 1.5 !important;
        text-align: right;
      }
    }
    .card__img {
      clip-path: polygon(0 0, 100% 0, 75% 100%, 0 100%);
    }
  }
}
@media screen and (max-width: 1400px) {
  .news-top {
    --border-width: 1rem;
    --border-color: #9786a6;
    --offset-img: 5rem;
  }
  .news-bottom {
    .card{
      &__content{
        margin-bottom: 0.5rem;
      }
      &__title{
        .limited-text{
          --snup: 4
        }
      }
    }
  }
}
@media screen and (max-width: 992px) {
  .circule-overlay-firth {
    display: none;
  }
  .circule-overlay-second {
    display: none;
  }
  .container-news {
    width: 95%;
    padding-top: 5rem;
  }
  .news-top {
    --border-width: 1.5rem;
    --offset-img: 5rem;
    // gap: 0.5rem;
    flex-wrap: wrap;
    width: 90%;
    margin: 0 auto;
    padding-bottom: 5rem;
    .card {
      flex: 1 0 calc(50% - var(--border-width) * 2);
    }
    .card-2 {
      .card__img {
        &::after {
          display: none;
        }
        &::before {
          width: 200%;
        }
      }
    }
    .card-3 {
      order: 4;
      .card__img {
        &::before {
          content: "";
          position: absolute;
          height: var(--border-width);
          width: 200%;
          background: var(--border-color);
          top: 0;
          left: 0;
        }
        &::after {
          content: "";
          position: absolute;
          width: var(--border-width);
          height: calc(100% + var(--offset-img));
          background: var(--border-color);
          top: 0;
          left: calc(0rem - var(--border-width));
        }
      }
    }
    .card-4 {
      order: 3;
      .card__img {
        &::before {
          content: "";
          position: absolute;
          height: var(--border-width);
          width: 200%;
          background: var(--border-color);
          bottom: 0;
          left: -100%;
        }
      }
    }
  }
  .news-bottom {
    margin: 0 auto;
    flex-direction: column;
    .card-1 {
      .data-news {
        text-align: left;
      }
    }
    .card-2 {
      .data-news {
        text-align: right;
      }
    }
  }
}

@media screen and (max-width: 767px) {
  .container-news {
    width: 100%;
    padding-top: 0rem;
  }
  .news-top {
    --border-width: 10px;
    --offset-img: 5rem;
    padding-bottom: 1em;
  }
  .card {
    flex: 0 1 calc(50% - var(--border-width) * 2);
  }
  .news-bottom {
    --translate-content: 0%;
    width: 100%;
    margin-top: 2rem;
    .card {
      &__content {
        margin: 0;
        padding: 0 0.6rem;
      }
      &__img {
        flex: 0 0 50%;
      }
    }
    .data-news {
      line-height: 1.5 !important;
    }
  }
}
</style>
